let carouselFirstTime = 0;
function ProductsCollectionCarouselUpdateStatus(carousel) {
  // console.log('update status');
  var ProductsCollectionSlideNumberCurrent = document.querySelector('.ProductsCollection .currentSlide');
  var ProductsCollectionNavigation = document.querySelector('.ProductsCollection .navigation');
  var slideNumber = carousel.selectedIndex + 1;

  ProductsCollectionSlideNumberCurrent.innerHTML = slideNumber;

  var previousButton = document.querySelector('.ProductsCollection .button--previous');
  var nextButton = document.querySelector('.ProductsCollection .button--next');

  if (carousel.slides.length <= 1) {
    ProductsCollectionNavigation.classList.add('hide');
  } else {
    ProductsCollectionNavigation.classList.remove('hide');
    var n = carousel.selectedIndex + 1;
    // console.log('carousel selected index = ' + n);
    // console.log('carousel length = ' + carousel.slides.length);
    if (carousel.selectedIndex + 1 >= carousel.slides.length) {
      nextButton.classList.add('hide');
      previousButton.classList.remove('hide');
    } else if (carousel.selectedIndex + 1 <= 1) {
      previousButton.classList.add('hide');
      nextButton.classList.remove('hide');
    } else {
      previousButton.classList.remove('hide');
      nextButton.classList.remove('hide');
    }
  }
  if (carouselFirstTime == 0) {
    carousel.resize();
    carouselFirstTime = 1;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  // Products Collection Carousel
  if (document.querySelector('.ProductsCollectionCarousel')) {
    var ProductsCollectionContainer = document.querySelector('.ProductsCollection');
    var ProductsCollectionCarousel = ProductsCollectionContainer.querySelector('.ProductsCollectionCarousel');

    var ProductsCollectionSlideNumber = ProductsCollectionContainer.querySelector('.slideNumber');
    var ProductsCollectionSlideNumberCurrent = ProductsCollectionSlideNumber.querySelector('.currentSlide');
    var ProductsCollectionSlideNumberTotal = ProductsCollectionSlideNumber.querySelector('.totalSlides');

    var previousButton = ProductsCollectionContainer.querySelector('.button--previous');
    var nextButton = ProductsCollectionContainer.querySelector('.button--next');

    var flktyProductsCollection = new Flickity(ProductsCollectionCarousel, {
      groupCells: true,
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: function () {
          ProductsCollectionSlideNumberCurrent.innerHTML = this.selectedIndex + 1;
          ProductsCollectionSlideNumberTotal.innerHTML = this.slides.length;
          // console.log('READY');
          ProductsCollectionCarouselUpdateStatus(this);

          // locoScroll.resize();
        },
      },
    });

    // previous btn
    previousButton.onclick = (event) => {
      flktyProductsCollection.previous();
      ProductsCollectionCarouselUpdateStatus(flktyProductsCollection);
    };

    // next btn
    nextButton.onclick = (event) => {
      flktyProductsCollection.next();
      ProductsCollectionCarouselUpdateStatus(flktyProductsCollection);
    };
  }
});
